import {
	AfterViewInit,
	Component,
	EventEmitter,
	NgZone,
	OnInit,
	Output,
	ViewChild
} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Travel} from '../../models/travel';
import {TravelsHandlerService} from '../../api-handlers/travels-handler.service';
import {SnackBarHandlerService} from '../../commons/snack-bar-handler.service';
import {Refill} from '../../models/refill';
import {RefillsHandlerService} from '../../api-handlers/refills-handler.service';


@Component({
	selector: 'app-insert-refills',
	templateUrl: './insert-refills.component.html',
	styleUrls: ['./insert-refills.component.scss']
})
export class InsertRefillsComponent implements OnInit, AfterViewInit {

	modalRef: BsModalRef;
	travelToRefill: Travel;
	refill: Refill = new Refill(undefined);
	@ViewChild('template', { static: false }) template;
	@ViewChild('videoRecElement', { static: true }) videoRecElement: any;
	@ViewChild('videoBoxElement', { static: true }) videoBoxElement: any;
	@Output() refillsCompleted = new EventEmitter<boolean>();
	@Output() isLoading = new EventEmitter<boolean>();
	no_camera = false;
	search_text = '';
	videoBox: any;
	videoRec: any;
	videoBoxSrc: any;
	videoRecSrc: any;


	dom_elements = {
		is_loading : false,
		box_url64: '',
		recive_url64: '',
		first_played: false,
		second_played: false,
		addRefuel_btn: {
			is_running: false,
			txt_run: 'SALVATAGGIO IN CORSO...',
			txt_not_run: 'SALVA RIFORNIMENTO'
		},
		insertRefuel: {
			is_running: false,
			txt_run: 'CREAZIONE RIFORNIMENTO IN CORSO...',
			txt_not_run: 'SALVA RIFORNIMENTO'
		},
		active_step: 1

	};

	constructor(
		public travelsHandlerService: TravelsHandlerService,
		public travelsService: TravelsHandlerService,
		public snackBarHandler: SnackBarHandlerService,
		private modalService: BsModalService,
		public refillsService: RefillsHandlerService,
		private ngZone: NgZone
	) { }

	ngOnInit() {
	}

	ngAfterViewInit(): void {
		/*this.videoBoxElement.changes.subscribe((comps: any) =>
    {
      this.videoBox = this.videoBoxElement.nativeElement;
      this.videoRec = this.videoRecElement.nativeElement;
      this.videoRec.srcObject = null;
      this.videoBox.srcObject = null;
    });*/

		/*setTimeout(() => {
      this.videoBox = this.videoBoxElement2.nativeElement;
      this.videoBox = this.videoBoxElement.nativeElement;

      this.videoRec = this.videoRecElement.nativeElement;
      this.videoRec.srcObject = null;
      this.videoBox.srcObject = null;
    });
*/
	}


	/*ngAfterViewChecked(): void {
    console.log('ngAfterViewChecked insertRefill');
    console.log(this.videoRecElement.toString());
  }*/

	showDialog(travelToRefill: Travel) {
		this.dom_elements.active_step = 1;
		this.addEnter();
		this.travelToRefill = travelToRefill;
		// this.travelToRefill.start_kilometers = '0';
		// this.travelToRefill.started_at_app = new Date();
		// this.vehicleToSet = new Vehicle(undefined);
		this.modalRef = this.modalService.show(this.template);
	}

	doRefill() {
		/*console.log("effettua rifornimento");
    this.refillsCompleted.emit();
    this.modalRef.hide();*/

		console.log('effettua rifornimento');
		this.dom_elements.insertRefuel.is_running = true;
		this.isRefillComplete().then(res => {
			if (res) {

				this.getCurrentPosition((lat, lon, alt) => {

					this.refill.latitude = lat;
					this.refill.longitude = lon;
					this.refill.altitude = alt;

					this.refill.travel = this.travelToRefill;

					this.refillsService.addRefill(this.refill).then((res2) => {
						this.resetRefill();
						this.refillsCompleted.emit();
						this.modalRef.hide();

						this.snackBarHandler.showSnackbar('Salvataggio eseguito con successo', 1000);
						this.dom_elements.insertRefuel.is_running = false;
					}, err => {
						console.log(err);
					}).catch(() => {
						this.snackBarHandler.showSnackbar('Attenzione, impossibile salvare. Riprova', 3000);
						this.dom_elements.insertRefuel.is_running = false;

					}).then(() => {

					});

				});
			} else {
				this.dom_elements.insertRefuel.is_running = false;
			}
		}).catch(() => {
			this.snackBarHandler.showSnackbar('Attenzione, impossibile salvare. Riprova', 3000);
			this.dom_elements.insertRefuel.is_running = false;

		});

	}

	isRefillComplete(): Promise<boolean> {
		return new Promise<boolean>((resolve, reject) => {

			if (!this.refill.quantity) {
				this.snackBarHandler.showSnackbar('Impostare quantità in litri', 3000);
				resolve(false);
			} else if (!this.refill.amount) {
				this.snackBarHandler.showSnackbar('Impostare importo speso', 3000);
				resolve(false);
			} else if (!this.refill.kilometers) {
				this.snackBarHandler.showSnackbar('Impostare i chilometri', 3000);
				resolve(false);
			}  else if (!this.refill.fuel_level) {
				this.snackBarHandler.showSnackbar('Impostare il livello del serbatoio prima del rifornimento', 3000);
				resolve(false);
			} else if (!this.refill.made_at) {
				this.snackBarHandler.showSnackbar('Impostare una data valida', 3000);
				resolve(false);
			} else if (!this.refill.box_pic) {
				this.snackBarHandler.showSnackbar('Scattare foto cruscotto', 3000);
				resolve(false);
			} else if (!this.refill.recive_pic) {
				this.snackBarHandler.showSnackbar('Scattare foto scontrino', 3000);
				resolve(false);
			} else if (isNaN(Number(this.refill.kilometers))) {
				this.snackBarHandler.showSnackbar('Valore kilometri non valido', 3000);
				resolve(false);
			} else if (isNaN(Number(this.refill.amount))) {
				this.snackBarHandler.showSnackbar('Valore spesa euro non valido', 3000);
				resolve(false);
			} else if (isNaN(Number(this.refill.quantity))) {
				this.snackBarHandler.showSnackbar('Valore quantità litri non valido', 3000);
				resolve(false);
			} else if ((Number(this.refill.amount) / Number(this.refill.quantity)) < 0.65 ||
				(Number(this.refill.amount) / Number(this.refill.quantity) > 3.00 )) {
				this.snackBarHandler.showSnackbar('Importo non coerente con la quantità di litri', 3000);
				resolve(false);
			} else {

				this.travelsService.getMaxKm(this.travelToRefill).then((res) => {
					console.log(res);
					if (Number(this.refill.kilometers) < res || Number(this.refill.kilometers) < Number(this.travelToRefill.start_kilometers)) {
						this.snackBarHandler.showSnackbar('Chilometri attuali minori del numero di chilometri impostati precedentemente', 3000);
						resolve(false);
					} else {
						resolve(true);
					}
				}).catch((er) => {
					resolve(false);
				});
			}
		});
	}

	getCurrentPosition(callbackFunction) {
		callbackFunction(null, null, null);
		// navigator.geolocation.getCurrentPosition((position) => {
		// 	callbackFunction(position.coords.latitude, position.coords.longitude, position.coords.altitude);
		// }, (err) => {
		// 	callbackFunction(null, null, null);
		// });
	}

	resetRefill() {
		this.refill = new Refill(undefined);
		this.refill.travel = this.travelToRefill;
	}

	addEnter() {
		if (this.dom_elements.active_step === 1) {
			this.startLoading();
			const browser = <any>navigator;

			browser.getMedia = (
				browser.getUserMedia ||
				browser.webkitGetUserMedia ||
				browser.mozGetUserMedia ||
				browser.msGetUserMedia
			);
			if (!browser.getMedia) {
				alert('Your browser doesn\'t have support for the navigator.getUserMedia interface.');
				this.stopLoading(true);
			} else {
				// Request the camera.
				try {
					browser.getMedia({ video: { facingMode: { exact: 'environment' } }, audio: false }, (stream) => {
						this.videoBoxSrc = stream;
						this.videoRecSrc = stream;
						this.videoRec.srcObject = this.videoRecSrc;
						this.videoBox.srcObject = this.videoBoxSrc;

						this.activateRecivePhoto();
						this.activateBoxPhoto();
					}, (err_) => {
						browser.mediaDevices.enumerateDevices().then((devices) => {
							let dev_trovato = null;
							devices.forEach((device) => {
								if (device.kind === 'videoinput') {
									if (dev_trovato === null) {
										dev_trovato = device;
									} else {
										if (device.label.toLowerCase().indexOf('back') !== -1) {
											dev_trovato = device;
										}
									}
								}
							});

							browser.getMedia({ video: { deviceId: { exact: dev_trovato.deviceId } }, audio: false }, (stream) => {
								this.videoBoxSrc = stream;
								this.videoRecSrc = stream;
								this.videoRec.srcObject = this.videoRecSrc;
								this.videoBox.srcObject = this.videoBoxSrc;
								this.activateRecivePhoto();
								this.activateBoxPhoto();
							}, (err) => {
								alert('There was an error with accessing the camera stream: ' + err.name);
								this.stopLoading(true);
							} );
						} );
					});
				} catch (e) {
					this.stopLoading(true);
				}

			}
		}
	}

	startLoading() {
		this.no_camera = false;
		this.dom_elements.is_loading = true;
		this.resetRefill();
		this.search_text = '';



		setTimeout(() => {
			this.videoBox = this.videoBoxElement.nativeElement;
			this.videoRec = this.videoRecElement.nativeElement;
			this.videoRec.srcObject = null;
			this.videoBox.srcObject = null;
		});

		this.travelsService.getMaxKm(this.travelToRefill).then((res) => {
			this.refill.kilometers = res.toString();
		}).catch((er) => {
		});

		this.videoBoxSrc = null;
		this.videoRecSrc = null;

		this.dom_elements.first_played =  false;
		this.dom_elements.second_played = false;
		this.dom_elements.recive_url64 = '';
		this.dom_elements.box_url64 = '';
		this.isLoading.next(true);
	}

	stopLoading(force: boolean) {
		if (force) {
			this.no_camera = true;
		}
		if (force || (this.dom_elements.first_played && this.dom_elements.second_played)) {
			this.dom_elements.is_loading = false;
			this.isLoading.next(false);
		}
	}


	addLeave() {
		this.deactivateAll();
	}

	deactivateRecivePhoto() {
		if (this.videoRec) {
			this.videoRec.srcObject = null;
			if (this.videoRecSrc) {
				this.videoRecSrc.getVideoTracks().forEach((track) => {
					track.stop();
				});

			}
			this.videoRec.pause();
		}
	}

	deactivateBoxPhoto() {
		if (this.videoBox) {
			this.videoBox.srcObject = null;
			if (this.videoBoxSrc) {
				this.videoBoxSrc.getVideoTracks().forEach((track) => {
					track.stop();
				});
			}
			this.videoBox.pause();
		}
	}

	activateBoxPhoto() {
		this.videoBox.play();
		this.videoBox.onplaying  = () => {
			this.dom_elements.second_played = true;
			this.stopLoading(false);
		};
	}

	activateRecivePhoto() {
		this.videoRec.play();
		this.videoRec.onplaying  = () => {
			this.dom_elements.first_played = true;
			this.stopLoading(false);
		};
	}

	deactivateAll() {
		this.deactivateRecivePhoto();
		this.deactivateBoxPhoto();
	}

	takePictureRecive() {
		const canvas = <HTMLCanvasElement>document.getElementById('cnvsRec');

		const hegihtToSet = canvas.width * this.videoRec.videoHeight / this.videoRec.videoWidth;

		this.drawPictureRec(this.videoRec, canvas.width, hegihtToSet);

	}

	drawPictureRec(toDraw: any, widthToSet, heightToSet) {
		const canvas = <HTMLCanvasElement>document.getElementById('cnvsRec');
		const ctx = canvas.getContext('2d');

		canvas.height = heightToSet;
		canvas.width = widthToSet;

		ctx.drawImage(toDraw, 0, 0, canvas.width, canvas.height);

		const contentType = 'image/png';
		this.dom_elements.recive_url64 = canvas.toDataURL(contentType);
		this.refill.recive_pic = this.dataURItoBlob(this.dom_elements.recive_url64);

		this.activateBoxPhoto();
	}

	takePictureBox() {

		const canvas = <HTMLCanvasElement>document.getElementById('cnvsBox');

		const hegihtToSet = canvas.width * this.videoBox.videoHeight / this.videoBox.videoWidth;

		this.drawPictureBox(this.videoRec, canvas.width, hegihtToSet);
	}

	drawPictureBox(toDraw: any, widthToSet, heightToSet) {
		const canvas = <HTMLCanvasElement>document.getElementById('cnvsBox');
		const ctx = canvas.getContext('2d');

		canvas.height = heightToSet;
		canvas.width = widthToSet;

		ctx.drawImage(toDraw, 0, 0, canvas.width, canvas.height);

		const contentType = 'image/png';
		this.dom_elements.box_url64 = canvas.toDataURL(contentType);
		this.refill.box_pic = this.dataURItoBlob(this.dom_elements.box_url64);

		this.activateBoxPhoto();
	}

	deletePicRecive() {
		this.dom_elements.recive_url64 = '';
		this.activateRecivePhoto();
	}

	deletePicBox() {
		this.dom_elements.box_url64 = '';
		this.activateBoxPhoto();
	}

	dataURItoBlob(dataURI) {
		const binary = atob(dataURI.split(',')[1]);
		const array = [];
		for (let i = 0; i < binary.length; i++) {
			array.push(binary.charCodeAt(i));
		}
		return new Blob([new Uint8Array(array)], {
			type: 'image/jpg'
		});
	}

	imageBoxLoaded(event) {
		console.log(event);
		if (event.target.files && event.target.files[0]) {
			const reader = new FileReader();
			reader.onload = ( event2 ) => {
				const image = new Image();
				image.onload = () => {
					const canvas = <HTMLCanvasElement>document.getElementById('cnvsBox');
					const hegihtToSet = canvas.width * image.height / image.width ;
					this.drawPictureBox(image, canvas.width, hegihtToSet);
				};
				image.src = event2.target['result'] as string;
			};
			reader.readAsDataURL(event.target.files[0]);
			event.target.value = null;
		}
	}

	imageRecLoaded(event) {
		console.log(event);
		if (event.target.files && event.target.files[0]) {
			const reader = new FileReader();
			reader.onload = ( event2 ) => {
				const image = new Image();
				image.onload = () => {
					const canvas = <HTMLCanvasElement>document.getElementById('cnvsRec');
					const hegihtToSet = canvas.width * image.height / image.width ;
					this.drawPictureRec(image, canvas.width, hegihtToSet);
				};
				image.src = event2.target['result'] as string;
			};
			reader.readAsDataURL(event.target.files[0]);
			event.target.value = null;
		}
	}


}
